module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_3.98314e48.jpg";